/**
 * Type for the window object in a Cypress environment.
 */
type CypressWindow = Window & {
  Cypress?: unknown;
};

/**
 * Check if the current environment is a Cypress environment.
 * @returns True if running in Cypress, false otherwise.
 */
export const isCypressEnvironment = (): boolean =>
  typeof window !== 'undefined' && 'Cypress' in (window as CypressWindow);
